import { createContext } from "react";

const ArrayContext = createContext({});

export default ArrayContext;
